import { useState } from "react";
import dayjs from "dayjs";
import MonthViewCalendar from "./MonthViewCalendar";
import WeekViewCalendar from "./WeekViewCalendar";
import DayViewCalendar from "./DayViewCalendar";
import YearViewCalendar from "./YearViewCalendar";
import { ChevronDownIcon, PlusIcon, ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/24/solid";

export default function Calendar() {
  const [view, setView] = useState("month");
  const [menuOpen, setMenuOpen] = useState(false);
  const [currentDate, setCurrentDate] = useState(dayjs());

  const renderView = () => {
    switch (view) {
      case "month":
        return <MonthViewCalendar currentMonth={currentDate} setCurrentDate={setCurrentDate} />;
      case "week":
        return <WeekViewCalendar currentWeek={currentDate} setCurrentDate={setCurrentDate} />;
      case "day":
        return <DayViewCalendar currentDay={currentDate} setCurrentDate={setCurrentDate} />;
      case "year":
        return <YearViewCalendar currentYear={currentDate} setCurrentDate={setCurrentDate} />;
      default:
        return <MonthViewCalendar currentMonth={currentDate} setCurrentDate={setCurrentDate} />;
    }
  };  

  const getHeaderTitle = () => {
    switch (view) {
      case "month":
        return currentDate.format("MMMM YYYY");
      case "week":
        return `Semaine du ${currentDate.startOf("week").format("DD MMM YYYY")}`;
      case "day":
        return currentDate.format("dddd, DD MMMM YYYY");
      case "year":
        return currentDate.format("YYYY");
      default:
        return currentDate.format("MMMM YYYY");
    }
  };

  return (
    <div className="w-full h-[92vh] mx-auto p-6 bg-gray-100 shadow-xl rounded-lg">
      {/* En-tête avancée */}
      <div className="flex items-center justify-between mb-6">
        <div className="text-xl font-semibold text-gray-700 ml-8">
          {getHeaderTitle()}
        </div>

        <div className="flex items-center gap-2">
            <div className="flex items-center border rounded-md overflow-hidden bg-white shadow-sm">
            {/* Chevon gauche (←) */}
            <button
                onClick={() => setCurrentDate((prev) => prev.subtract(1, view))}
                className="px-3 py-1.5 hover:bg-gray-100 transition"
            >
                <ChevronLeftIcon className="w-4 h-4 text-gray-600" />
            </button>

            {/* Today */}
            <button
                onClick={() => setCurrentDate(dayjs())}
                className="px-4 py-1.5 text-sm text-gray-800 hover:bg-gray-100 transition font-semibold"
            >
                Today
            </button>

            {/* Chevron droit (→) */}
            <button
                onClick={() => setCurrentDate((prev) => prev.add(1, view))}
                className="px-3 py-1.5 hover:bg-gray-100 transition"
            >
                <ChevronRightIcon className="w-4 h-4 text-gray-600" />
            </button>
            </div>

            <div className="relative">
                {/* Bouton principal */}
                <button
                    className="flex items-center justify-between gap-1 px-4 py-1.5 border rounded-md text-sm font-medium text-gray-800 bg-white hover:bg-gray-100 transition"
                    onClick={() => setMenuOpen(!menuOpen)}
                >
                    {view.charAt(0).toUpperCase() + view.slice(1)} view
                    <ChevronDownIcon className="w-4 h-4 text-gray-500" />
                </button>

                {/* Menu déroulant */}
                {menuOpen && (
                    <div className="absolute right-0 mt-2 w-40 bg-white border rounded-md shadow-lg z-50">
                    {["month", "week", "day", "year"].map((v) => (
                        <button
                        key={v}
                        onClick={() => {
                            setView(v);
                            setMenuOpen(false);
                        }}
                        className={`block w-full text-left px-4 py-2 text-sm hover:bg-gray-100 capitalize ${
                            v === view ? "bg-gray-100 font-semibold text-blue-600" : ""
                        }`}
                        >
                        {v} view
                        </button>
                    ))}
                    </div>
                )}
            </div>

            <div className="h-6 w-px bg-gray-300 mx-2"></div>

            <button
                onClick={() =>
                    window.open("https://calendar.google.com/calendar/u/0/r/eventedit", "_blank")
                }
                className="inline-flex items-center gap-2 px-4 py-1.5 text-sm font-medium bg-violet-600 text-white rounded-md hover:bg-violet-700 transition-shadow shadow-sm"
                >
                <PlusIcon className="w-4 h-4" />
                Add event
            </button>
        </div>
      </div>

      {/* Affichage dynamique des vues */}
      {renderView()}
    </div>
  );
}
